// Re-exports via `const` declarations instead of `export { } from` so that TypeScript
// treats this file as the canonical source of each symbol. This ensures VS Code IntelliSense
// suggests `lib/tolgee` (not `@winnin/i18n`) when auto-importing these hooks.
import {
  useTranslate as _useTranslate,
  useLanguage as _useLanguage,
  useSetLanguage as _useSetLanguage,
  useCurrentLanguage as _useCurrentLanguage,
  I18nProvider,
  T,
  defineTranslateKeys,
  withTolgee,
} from '@winnin/i18n'

export type {
  TranslateFunction,
  TranslateOptions,
  TranslateKeys,
  LocationLanguage,
  WithTolgeeProps,
} from '@winnin/i18n'

export { I18nProvider, T, defineTranslateKeys, withTolgee }

export const useTranslate = _useTranslate
export const useLanguage = _useLanguage
export const useSetLanguage = _useSetLanguage
export const useCurrentLanguage = _useCurrentLanguage
